export const nl = {
  title: 'Potentieel windsnelheid',
  subtitle: '1 km, wereldwijd, DTU/Wereldbankgroep/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Functie',
      value: 'Gemiddelde windsnelheid voor elke locatie op aarde',
    },
    {
      label: 'Resolutie',
      value: '1 kilometer',
    },
    {
      label: 'Geografische dekking',
      value: 'Globaal',
    },
    {
      label: 'Bron',
      value: '\tDTU/Wereldbankgroep/ESMAP',
    },
    {
      label: 'Frequentie',
      value: '',
    },
    {
      label: 'Datum van inhoud',
      value: '',
    },
    {
      label: 'Waarschuwingen',
      value:
        'De GWA maakt gebruik van twee belangrijke modelleringscomponenten die onzekerheid in de berekeningen kunnen introduceren. Deze componenten zijn de mesoschaalmodellering en de microschaalmodellering.',
    },
    {
      label: 'Licentie',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'De Global Wind Atlas (GWA) dataset over de gemiddelde windsnelheid is gegenereerd door het Department of Wind Energy van de Technische Universiteit van Denemarken (DTU), de Wereldbankgroep en het Energy Sector Management Assistance Program (ESMAP).\n\nDe gemiddelde windsnelheid is een van de belangrijkste prestatie-indicatoren van de productie van windenergie. GWA begint met gegevens over windsnelheden met een lage resolutie en converteert deze naar gegevens met een hoge resolutie met behulp van een downscalingproces. Het resultaat van dit proces is een model van lokale windklimaten over de hele wereld (behalve de Noord- en Zuidpool en verre offshore oceaangebieden) met een resolutie van 1 kilometer voor drie hoogtes: 50 meter, 100 meter en 200 meter.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
